import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";

const ConfirmationDialog = ({
  open,
  onClose,
  handleResponse,
  message = "Are you sure you want to continue?",
  title = "Confirmation",
}) => {
  return (
    <Dialog
      fullWidth={true}
      maxWidth={"xs"}
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        <span id="modal-header">
          <b>{title}</b>
        </span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Grid container style={{ padding: "0 10px" }}></Grid>
        </DialogContentText>
        {message}
      </DialogContent>
      <DialogActions>
        <Button
          id="btn-confirm"
          variant="contained"
          size="small"
          onClick={() => {
            handleResponse(true);
          }}
          color="primary"
        >
          <CheckIcon fontSize="small" className="app-button-icon" /> Yes
        </Button>

        <Button
          id="btn-reject"
          variant="contained"
          size="small"
          onClick={() => {
            onClose(false);
          }}
          color="secondary"
        >
          <CloseIcon fontSize="small" className="app-button-icon" /> No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
